import React from "react";

export const StartConversation = () => {
  return (
    <>
      <section className="start-a-conversation sec-padd">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 mx-auto text-center">
              <h2 className="section-title">Interested in Starting a Conversation? </h2>
              <p>
                Whether you’re looking to fill content gaps, deliver highly
                relevant casino experiences, or boost revenue and streamline
                operations, contact us today to request a demo.
              </p>
              <div className="motto">Everything is possible.</div>
              <a href="/connect" className="btn btn_white">
                Contact us
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
